<template>
<div>
    <div v-if="modal == true" class="overlay" @click="openModal()"></div>
    <transition name="modal">
        <div v-if="modal == true">
                <div class="modal">
                    <div class="modal-header"
                        v-bind:style="{ backgroundImage: 'url(' + data.image.image + ')' }"
                        style="background-position: center;
                                background-size: cover;"></div>
                        <div v-if="!success">        
                            <form action="" v-on:submit.prevent>
                                <div class="row">
                                    <div class="email-wrapper">
                                        <label for="">Email</label>
                                        <input v-model="payload.email" name="email" class="email-input" type="email" placeholder="ex: name@gmail.com" required>
                                    </div>
                                    <div class="country-wrapper">
                                        <div v-if="countryError" class="error-text">Please Choose A Country</div>
                                        <label for="country">Location</label>
                                        <select v-model="payload.country" class="country-select" name="country" id="">
                                            <option value="Please Choose One" selected>Please Choose One</option>
                                            <option value="United States">United States</option>
                                            <option value="Europe">Europe</option>
                                            <option v-for="country in availableCountries" :key="country.id"> {{ country.text }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                        <div class="inputs">
                                            <div v-if="codeError" class="error-text">Please verify the code and try again</div>
                                            <label for="">Code</label>
                                            <div class="input-wrapper">
                                                <input type="text" v-model="payload.code[0]" class="code-input" maxlength="1" required>  
                                            </div>
                                            <div class="input-wrapper">
                                                <input type="text" v-model="payload.code[1]" class="code-input" maxlength="1" required>  
                                            </div>
                                            <div class="input-wrapper">
                                                <input type="text" v-model="payload.code[2]" class="code-input" maxlength="1" required>  
                                            </div>
                                            <div class="dash">
                                                <span>-</span>
                                            </div>
                                            <div class="input-wrapper">
                                                <input type="text" v-model="payload.code[3]" class="code-input" maxlength="1" required>  
                                            </div>
                                            <div class="input-wrapper">
                                                <input type="text" v-model="payload.code[4]" class="code-input" maxlength="1" required>  
                                            </div>
                                            <div class="input-wrapper">
                                                <input type="text" v-model="payload.code[5]" class="code-input" maxlength="1" required>  
                                            </div>
                                        </div>
                                        <div class="email-opt-in">
                                            <input type="checkbox" v-model="payload.email_opt_in"> <p> Stay up to date with everything American Documents</p>
                                        </div>
                                </div>
                                <p class="legal">By submitting your email address above you are agreeing to the <a class="legal-link" href="https://www.timex.com/privacy-policy.html" >Privacy Policy</a> and <a class="legal-link" href="https://www.timex.com/terms.html" >Terms & Conditions</a></p>
                                <button class="download-button" @click="download()">
                                    <span v-if="!downloading">DOWNLOAD PRINT</span>
                                    <span v-if="downloading">Downloading...</span>
                                </button>
                            </form>
                        </div>
                        <div v-if="success">
                            <Check />
                            <p class="legal">By submitting your email address above you are agreeing to the <a class="legal-link" href="https://www.timex.com/privacy-policy.html" >Privacy Policy</a> and <a class="legal-link" href="https://www.timex.com/terms.html" >Terms & Conditions</a></p>
                        </div>
                </div>
        </div>
    </transition>
    <div class="image-contain">
        <div class="main-image">
            <div class="image-wrapper">
                <img :src="data.image.image" alt="">
                <div class="lower-content">
                    <div class="content">
                        <h5 class="image-title mt3 regular">{{ data.image.name }}</h5>
                        <span class="document-number heavy">{{ data.image.document_number }}</span>
                    </div>
                    <div class="download-icon"
                        v-if="data.image.dl == 'true'" @click="openModal()">
                        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="100" height="125" viewBox="0 0 100 125" fill="#999"><g opacity="1"><path d="M82.6 73.3v9.3H17.5v-9.3H8.1v18.5h83.7V73.3z"/><path d="M81.6 73.3v9.3l1-1H17.5l1 1v-9.3c0-.5-.5-1-1-1H8.2c-.5 0-1 .5-1 1v18.6c0 .5.5 1 1 1h83.7c.5 0 1-.5 1-1V73.3c0-.5-.5-1-1-1h-9.3c-1.3 0-1.3 2 0 2h9.3l-1-1v18.6l1-1H8.2l1 1V73.3l-1 1h9.3l-1-1v9.3c0 .5.5 1 1 1h65.1c.5 0 1-.5 1-1v-9.3c0-1.3-2-1.3-2 0z"/><g><path d="M36 8.1v37.2H17.5l32.5 28 32.6-28H64V8.1z"/><path d="M35 8.1v37.2l1-1H17.4c-.8 0-1.4 1.1-.7 1.7 10.9 9.4 21.7 18.7 32.6 28 .4.4 1 .4 1.4 0 10.8-9.3 21.7-18.6 32.6-27.9.7-.6.1-1.7-.7-1.7H64l1 1V8.2c0-.5-.5-1-1-1H36.1c-1.3 0-1.3 2 0 2H64l-1-1v37.2c0 .5.5 1 1 1h18.6c-.2-.6-.5-1.1-.7-1.7C71 53.9 60.1 63.2 49.3 72.5h1.4C39.9 63.2 29 53.9 18.2 44.6c-.2.6-.5 1.1-.7 1.7h18.6c.5 0 1-.5 1-1V8.1C37 6.9 35 6.9 35 8.1z"/></g></g></svg>
                    </div>
                </div>
                <div class="bottom">
                        <Thumbnail 
                        v-for="(item,index) in data.pagination"
                        :key="index"
                        :data="item"/>
                </div> 
            </div>
        </div>
    </div>
    {{ state }}
</div>
</template>

<script>
import axios from 'axios';
import Router from 'vue-router';
import {store} from '../store';

import Thumbnail from './Thumbnail.vue';
import Check from './Check.vue';
import { base64StringToBlob } from 'blob-util'
import {isoCountries} from '../countrydata.js';

export default {
  name: 'ImageView',
  props: ['d'],
  components: { Thumbnail, Check },
  data() {
    return {
      data: this.$store.state.selectedImage,
      gallery: this.$store.state.gallery,
      currentPath: this.$store.state.currentPath,
      modal: false,
      payload: {
          country: 'Please Choose One',
          code: []
      },
      downloading: false,
      success: false,
      codeError: false,
      countryError: false,
      availableCountries: isoCountries
    }
  },
    watch: {
        $route (to, from) {
            let path = window.localStorage.getItem("currentPath");
            this.$store.dispatch("updateCurrentPath", path)
        }
    },
    computed: {
        state: function () {
            this.payload.document = this.$store.state.selectedImage.image.download_document_number
        }
    },
  created() {
    if(!this.data.pagination.length) {
      this.$router.push(window.localStorage.getItem("currentPath"))
    }
    this.payload.document = this.$store.state.selectedImage.image.download_document_number
    this.payload.gallery = window.localStorage.getItem("currentPath");
  },
  methods: {
      download() {

          this.codeError = false;
          this.countryError = false;

          if(this.payload.country == 'Please Choose One') {
              this.countryError = true;
              return
          }

          let p = {              
            ...this.payload,
            document: parseInt(this.payload.document),
            // removing the '/' along with '-' and converting to title-case
            gallery: (this.currentPath === '/') ? 'All Documents' : this.payload.gallery.slice(1,this.payload.gallery.length).split("-").map( item => item[0].toUpperCase() + item.slice(1,item.length) ).join(" "),     
            // converting array of 6 numbers to string
            code: this.payload.code.toString().split(',').join('')
        }

        let getPrint = async () => {
            this.downloading = true;
            let f = await axios({
                method: 'post',
                url: 'https://admin.ad.arbor.design/wp-json/timex-american-documents/v1/redeem',
                data: { ...p }
            })
            .then( (response) => {
                if(response.data.success == true) {
                    this.success = true;
                }
                
                if(response.data.success == 'false') {
                    console.log('response is bad');
                    response.data.reasons.forEach( (item) => {
                        (item == "BAD_CODE") ? this.codeError = true : ''
                    })
                }
                if (response.data.success === true) {
                    this.$ga.event({
                        dimension1: p.code,
                        dimension2: p.gallery,
                        dimension3: p.purchase_location,
                        dimension4: p.document.toString(),
                        dimension5: p.country,
                        eventCategory: 'americandocuments',
                        eventAction: 'redeem',
                        eventLabel: 'Code Redemption',
                        eventValue: 1
                    });
                    let blob = base64StringToBlob(response.data.base64_image, 'image/jpeg')
                    var element = document.createElement('a');
                    element.setAttribute('href', URL.createObjectURL(blob) );
                    element.setAttribute('download', response.data.filename);
                    element.click();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
            await f
            this.downloading = false;
        }

        getPrint()
      },
    openModal() {
        this.modal = !this.modal;
        setTimeout( () => window.dispatchEvent(new Event('input-auto-advance')),200)   
    }
  }
}
</script>

<style scoped lang="scss">

textarea,
input.text,
input[type="text"],
input[type="button"],
input[type="submit"],
.input-checkbox {
-webkit-appearance: none;
border-radius: 0;
}

form {
    width: 95%;
    max-width: 500px;
    margin: 30px auto;
    @media screen and (min-width: 600px) {
        width: 80%;
    }
}

select {
    -webkit-appearance: none;
    border: none;
    background: white;
    border-bottom: 1px black solid;
    border-radius: 0;
    padding: 2px;
    font-size: 16px;
}
label {    
    padding-left: 5px;
    display: block;
}


.image-contain {
    max-width: 788px;
    margin: 0 auto;
}
.email-wrapper,
.country-wrapper,
.inputs { padding: 10px; }

.email-wrapper { 
    float: left;
    width: 100%;
    @media screen and (min-width: 500px) {
        width: 50%;
    }
}

.email-opt-in {
    display: flex;
    flex: 1;
    align-items: center;
    & input {
        margin-right: 10px;
    }
}

.country-wrapper {
    float: left;
    width: 100%;
    overflow: hidden;
    @media screen and (min-width: 500px) {
        width: 50%;
    }
}

.email-input {
    border: none;
    border-bottom: 1px black solid;
    width: 100%;
    font-size: 16px;
    padding: 10px 5px;
    border-radius: 0;
    &:focus { outline: none; }
}

.country-select { 
    width: calc(100% + 30px);
    padding: 10px 5px;
    border-radius: 0;
    &:focus { outline: none; }
}

.inputs {
    width: 100%;
    max-width: 319px;
    float: left;
    @supports(display: flex) {
        float: none;
        flex: 1 300px;
    }
    @media screen and (min-width: 600px) {
        max-width: 255px;
    }
}
.input-wrapper,
.dash {
    float: left;
    width: 41px;
    padding: 3px;
    @media screen and (min-width: 600px) {
        width: 33px;
    }
}

.input-wrapper input { width: 100%; }

.dash { text-align: center; }

.code-input{ 
    width: 100%;
    font-size: 16px;
    text-align: center;
    text-transform: uppercase;
    border: none;
    background: white;
    border-bottom: 1px black solid;
}

.error-text { color: #ff7373; }

.download-button {
    display: block;
    margin: 0 auto;
    margin-top: 40px;
    padding: 15px 50px;
    background: #d3d3d3;
    font-size: 14px;
    border: none;
    transition: all ease-in 300ms;
    &:hover, &:focus {
        cursor: pointer;
        outline: none;
        color: white;
        background: #333;
    }
    @media screen and (min-width: 400px) {
        padding: 15px 100px;
    }
}

.legal {
    font-size: 14px;
    text-align: center;
    @media screen and (min-width: 560px) {
        margin-top: 70px;
        margin-bottom: 35px;
    }
}

.row {
    display: block;
    width: 100%;
    @supports(display: flex) {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
}

.lower-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.content {
    float: left;
    margin-left: 10px;
    @supports(display: flex) {
        flex: 1;
    }
}

.download-icon { 
    float: right;
    width: 50px;
    height: 50px;
    margin-top: 10px;
    margin-right: 10px;
    &:hover {
        cursor: pointer;
        & svg {
            fill: #555;
        }
    }
    & svg {
        width: 100%;
        height: 100%;
        transition: fill ease-out 350ms;
    }
}


*::after {
content: "";
display: table;
clear: both;
}

.bottom {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
}

.main-image {
  display: block;
  width: 100%;
  margin-bottom: 40px;
}

.main-image img {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    // max-height: 800px;
}

.image-wrapper {
    display: block;
    width: 100%;
}


.modal {
    position: absolute;
    width: 90%;
    max-width: 760px;
    background: white;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 200000000;
    transition: 200ms ease-out;
}

.modal-header {
    width: 100%;
    height: 400px;
    background-position: center;
    background-size: 100%;
}

.modal-content {
    padding: 20px;
}

.overlay {
    position: fixed;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 10000;
}

.legal-link {
    font-family: 'Gotham Narrow Medium';
}



.main-image {
    height: 65vh;
    width: 100%;
    & img {
        max-height: 100%;
        max-width: 100%;
    }
}

.image-wrapper { height: 100%; }





</style>



// WEBPACK FOOTER //
// src/components/ImageView.vue